import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { BaseMiscApiService } from '@common/api/base-misc-api.service';
import { AppConstants } from '@apps/app.constants';

import { UpsertAssetViewModel } from '../models';
import { EnrichedAssetApi } from './models';

@Injectable({
    providedIn: 'root'
})
export class AssetMiscApiService extends BaseMiscApiService
{
    constructor (
        http: HttpClient
    )
    {
        super(http);

        this.segmentRoot = AppConstants.Configuration.apiUrlCmdb;
        this.segmentApi = '/cmdb/assets';
    }

    getAll (type: string): Observable<EnrichedAssetApi[]>
    {
        if (AppConstants.IsDataLocal('cmdb'))
        {
            return this.http.get<EnrichedAssetApi[]>('assets/data/cmdb/enriched-assets.json');
        }

        return this.get<EnrichedAssetApi[]>(`/${type}`);
    }

    attachTag (identifier: string, upsertAssetViewModel: UpsertAssetViewModel): Observable<EnrichedAssetApi>
    {
        return this.post<EnrichedAssetApi>(`/${identifier}`, upsertAssetViewModel);
    }

    detachTag (typeName: string, identifier: string, tagId: string): Observable<EnrichedAssetApi>
    {
        return this.delete(`/${identifier}/${typeName}/${tagId}`);
    }
}
